<template>
  <div class="verovioComponent" ref="verovioContainer"><div :class="purpose" ref="mei">
    <div class="placeholder">no transcript available ...</div>
  </div></div>
</template>

<script>
import { draft2score, draft2page, addSbIndicators, CSSselectables } from '@/tools/mei.js'
import { resolveSbIndicators, improveAtSvg } from '@/tools/annotatedTranscripts.js'
import { mapGetters } from 'vuex'
// import { cleanUpDiplomaticTranscript } from '@/tools/diplomaticTranscripts.js'

export default {
  name: 'VerovioComponent',
  components: {

  },
  props: {
    purpose: String,
    type: String,
    getter: String,
    pathGetter: String,
    scale: {
      type: String,
      default: '2'
    }
  },
  computed: {
    ...mapGetters(['diploPageBackgroundVerovioOptions', 'annotTransVerovioOptions'])
  },
  watch: {
    scale (newScale, oldScale) {
      const fac = +newScale / +oldScale
      const hscroll = this.$refs.verovioContainer.scrollLeft
      this.$refs.verovioContainer.scrollTo({ left: hscroll * fac, behaviour: 'instant' })
      this.render()
    }
  },
  methods: {
    async render () {
      const meiDom = this.$store.getters[this.getter]

      if (!meiDom) {
        // console.log('VerovioComponent:render(): No data available.')
        this.$refs.mei.innerHTML = '<div class="placeholder"><!-- loading data… -->select writing zone ...</div>'
        return false
      }

      try {
        this.removeListeners()
        if (this.type === 'annotTrans') {
          const resolvedDraft = draft2score(meiDom)[0]
          const addedSbIndicators = addSbIndicators(resolvedDraft)
          // console.log('VerovioComponent', meiDom, addedSbIndicators)

          const svg = await this.$store.getters.annotatedTranscriptForWz(addedSbIndicators)
          const localCopy = svg.repeat(1)
          const left = this.$refs.verovioContainer.scrollLeft
          // console.log('VerovioComponent left', left)
          this.$refs.mei.innerHTML = localCopy

          if (+this.scale > 0 || !this.scale) {
            const nre = /^([0-9.]*)([a-z]*)$/
            const whnum = (att) => +att.match(nre)[1]

            const svgDom = resolveSbIndicators(this.$refs.mei.querySelector('svg'), meiDom, this.$store.getters)
            improveAtSvg(svgDom, meiDom)
            const svgWidth = whnum(svgDom.getAttribute('width'))
            const svgHeight = whnum(svgDom.getAttribute('height'))
            const percHeight = 10 * +this.scale
            const percWidth = percHeight * svgWidth / svgHeight
            // console.log(`VerovioComponent width="${svgWidth}" height="${svgHeight}"`)
            svgDom.setAttribute('viewBox', `0 0 ${svgWidth} ${svgHeight}`)
            svgDom.removeAttribute('width')
            svgDom.removeAttribute('height')
            svgDom.setAttribute('style', `width: ${percWidth}%; height: ${percHeight}%; max-width: none; max-height: none;`)
          }

          this.$refs.verovioContainer.scrollTo({ left, behaviour: 'smooth' })
        }

        if (this.type === 'diploTrans') {
          const resolvedTrans = draft2page(meiDom)

          const svg = await this.$store.getters.diplomaticTranscriptForWz(resolvedTrans)
          const localCopy = svg.repeat(1) // cleanUpDiplomaticTranscript(svg.repeat(1))
          this.$refs.mei.innerHTML = localCopy
        }

        this.addListeners()
      } catch (err) {
        console.warn('VerovioComponent:render(): Unable to render file: ' + err, err)
      }
    },
    removeListeners () {
      this.$refs.mei.removeEventListener('click', this.clickListener)
      this.$refs.mei.removeEventListener('mouseover', this.hoverListener)
      this.$refs.mei.removeEventListener('mouseout', this.hoverListener)
      /* const els = this.$refs.mei.querySelectorAll(selectables)
      els.forEach((elm) => elm.removeEventListener('click', this.clickListener)) */
    },
    addListeners () {
      this.$refs.mei.addEventListener('click', this.clickListener)
      this.$refs.mei.addEventListener('mouseover', this.hoverListener)
      this.$refs.mei.addEventListener('mouseout', this.hoverListener)
      /* const els = this.$refs.mei.querySelector('selectables')
      els.forEach((elm) => elm.addEventListener('click', this.clickListener)) */
    },
    async clickListener (e) {
      const target = e.target.closest(CSSselectables)
      if (target !== null) {
        const name = target.getAttribute('data-class')
        const id = (name === 'dots') ? target.closest('.note, .rest').getAttribute('data-id') : target.getAttribute('data-id')
        const measure = target.closest('.measure').getAttribute('data-id')
        const meiDom = this.$store.getters[this.getter]
        const meiElem = meiDom.querySelector('*[*|id="' + id + '"]')
        let staff
        if (target.closest('.staff') && target.closest('.staff').hasAttribute('data-n')) {
          staff = target.closest('.staff')?.getAttribute('data-n')
        } else if (meiElem && meiElem.hasAttribute('staff')) {
          staff = meiElem.getAttribute('staff')
        } else if (meiElem && meiElem.hasAttribute('startid')) {
          const startid = meiElem.getAttribute('startid').substring(1)
          const startElem = meiDom.querySelector('*[*|id="' + startid + '"]')
          staff = startElem.closest('staff').getAttribute('n')
        } else {
          staff = 1
        }
        const path = this.$store.getters[this.pathGetter]

        const dtPath = target.closest('g[data-dt-path]').getAttribute('data-dt-path')
        // console.log('\n841 clicked verovio\nname: ' + name + '\nid: ' + id + '\nmeasure: ' + measure + '\npath: ' + path + '\npurpose: ' + this.purpose + '\ndtPath: ' + dtPath)
        const cvpayload = {
          meiDom,
          path,
          dtPath,
          id,
          name,
          measure,
          staff,
          purpose: this.purpose,
          callback: () => { this.render() }
        }
        if (name === 'dots') {
          const eliptElems = target.querySelectorAll('ellipse')
          const cx = [...eliptElems].sort((a, b) => parseInt(a.getAttribute('cx')) - parseInt(b.getAttribute('cx')))
          for (const di in cx) {
            if (e.target === eliptElems[di]) {
              cvpayload.dotidx = parseInt(di) + 1
              console.log(668, 'dot idx:', cvpayload.dotidx, 'from cx values:', cx, 'and target:', e.target)
              break
            }
          }
        }
        // console.log(671, 'cvpayload', cvpayload)
        if (name === 'barLine' && e.target.localName === 'use') {
          cvpayload.context = 'repeatDot'
        }

        if (name === 'keyAccid') {
          const keySig = target.closest('.keySig')
          const flat = +keySig.getAttribute('data-sig') < 0
          const keyAccids = keySig.querySelectorAll('.keyAccid')

          cvpayload.keyAccid = 0

          let keyAccidN = 0
          for (const ka of keyAccids) {
            if (ka.getAttribute('data-id') === id) {
              cvpayload.keyAccid = keyAccidN
              break
            }
            keyAccidN += 1
          }
          if (flat) {
            cvpayload.keyAccid *= -1
          }
        }
        /* if (name === 'tie' || name === 'slur') {
          console.log('clicked tie/slur', target)
        } */

        // console.log('661 clicked verovio', cvpayload)
        this.$store.dispatch('clickedVerovio', cvpayload)
      }
    },
    // TODO: make global getter in score to retrieve related objects
    hoverListener (e) {
      const hilite = (target) => target?.classList[(activate ? 'add' : 'remove')]('highlightHover')
      const activate = e.type === 'mouseover'
      const target = e.target.closest(CSSselectables)
      if (target !== null) {
        // console.log('hover:', target)
        hilite(target)
        const corresp = target.getAttribute('data-corresp')
        if (corresp) {
          const dtid = corresp.split('#')[1]
          // console.log(activate, this.$store.getters.activeWritingZone, dtid)
          const dtdoc = this.$store.getters.diplomaticTranscriptForCurrentWz
          const dtelm = dtdoc?.querySelector(`[*|id="${dtid}"]`)
          const dtsvg = document.querySelector(`[*|data-id="${dtid}"]`)
          hilite(dtsvg)
          // console.log(dtelm.parentElement, dtelm, dtsvg)
          const getFacs = elm => {
            if (elm.hasAttribute('facs')) {
              return elm.getAttribute('facs')
            }
            if (elm.parentElement) {
              return getFacs(elm.parentElement)
            }
            return ''
          }
          if (dtelm) {
            const facs = getFacs(dtelm)
            const shapes = facs.split(' ').map(furl => {
              const shapeid = furl.split('#')[1]
              return document.querySelector(`[*|id="${shapeid}"]`)
            })
            shapes.forEach(hilite)
          }
          // console.log(shapes)
        }
      }
    },
    /**
     * adds a highlighted class to the element with the given id
     * @param {*} newActivation
     * @param {*} oldActivation
     */
    activateElement (newActivation, oldActivation) {
      if ((!newActivation && oldActivation) || (oldActivation && newActivation !== oldActivation)) {
        const oldEl = this.$refs.mei.querySelector('*[data-id="' + oldActivation.id + '"]')
        if (oldEl) {
          oldEl.classList.remove('highlighted')
        }
      }
      if (newActivation) {
        const newEl = this.$refs.mei.querySelector('*[data-id="' + newActivation.id + '"]')
        if (newEl) {
          newEl.classList.add('highlighted')
        }
      }
    }
  },
  mounted: function () {
    // eslint-disable-next-line
    // this.vrvToolkit = new verovio.toolkit()
    // console.log('932: mounting verovio component')
    this.vrvToolkit = this.$store.getters.verovioToolkit
    this.vrvToolkit.setOptions(this.annotTransVerovioOptions)

    this.unwatchData = this.$store.watch((state, getters) => getters[this.getter],
      (newCode, oldCode) => {
        if (newCode !== null) {
          this.render()
        }
      })

    this.unwatchActivations = this.$store.watch((state, getters) => getters.diploTransActivationsInAnnotTrans,
      (newActivation, oldActivation) => {
        if (this.purpose === 'transcribing') {
          this.activateElement(newActivation, oldActivation)
        }
      })

    this.unwatchDTElementId = this.$store.watch((state, getters) => getters.activeDiploTransElementdIds,
      (newID, oldID) => {
        if (this.purpose === 'transcribing') {
          // console.log(oldID.at, '=>', newID.at, this.$refs.mei.querySelectorAll(`[data-id="${newID.at}"]`))
          this.$refs.mei.querySelectorAll(`[data-id="${oldID.at[0]}"]`).forEach(e => e.classList.remove('highlightDTChain'))
          this.$refs.mei.querySelectorAll(`[data-id="${newID.at[0]}"]`).forEach(e => e.classList.add('highlightDTChain'))
        }
      })
    /*
    this.unwatchPageXML = this.$store.watch((state, getters) => getters.xmlCode,
      (newCode, oldCode) => {
        this.render()
      })
     */
    this.render()
  },
  beforeUnmount () {
    this.unwatchData()
    this.removeListeners()
    this.unwatchActivations()
    this.unwatchDTElementId()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '@/css/_variables.scss';

.verovioComponent {
  margin: 0;
  padding: .3rem;
  border: $lightBorder;
  border-radius: .3rem;
  background-color: #ffffff;
  box-shadow: 0 0 .3rem #00000066 inset;
  height: 100%;
  width: 100%;
  overflow: scroll;

  svg *:not(.measure):not(.staff)[data-corresp] {
    fill: $svgUsedShapeColor;
    stroke: $svgUsedShapeColor;
    color: $svgUsedShapeColor;
  }

  svg .supplied {
    fill: $svgSuppliedColor;
    stroke: $svgSuppliedColor;
    color: $svgSuppliedColor;
  }

  svg .highlighted {
    fill: $scoreHighlightedColor;
    stroke: $scoreHighlightedColor;
    color: $scoreHighlightedColor;
  }

  svg .barLine.highlighted path {
    fill: $scoreHighlightedColor;
    stroke: $scoreHighlightedColor;
    stroke-width: 60;
    color: $scoreHighlightedColor;
  }

  svg .barLine path:hover {
    stroke-width: 80;
  }

  .placeholder {
    font-size: 24p;
    font-weight: bold;
    font-style: italic;
    color: gray;
  }

  &.transcribing svg {
    max-width: 150%;
    max-height: 150%;
  }

  svg g.note:not(.bounding-box) g.accid:not(.highlighted):not(*[data-corresp]) {
    stroke: black;
    fill: black;
  }
  svg g.note:not(.bounding-box) g.verse:not(.highlighted):not(*[data-corresp]) {
    stroke: black;
    fill: black;
  }
  svg g.beam:not(.bounding-box) > g:not(.highlighted):not(*[data-corresp]) {
    stroke: black;
    fill: black;
  }

  svg g.dots:not(.bounding-box) ellipse:not(*[data-corresp]) {
    fill: black;
    stroke: black;
  }

  svg g.artic:not(.data-corresp) {
    fill: black;
    stroke: black;
  }

  svg g.measure[data-corresp] .barLine path {
    fill: $svgUsedShapeColor;
    stroke: $svgUsedShapeColor;
    color: $svgUsedShapeColor;
  }

  svg .bounding-box rect {
    display: none;
  }

  svg g.dir.sb {
    font-style: normal;
  }

  svg .dots:not([data-corresp]) {
    fill: currentColor;
    stroke: currentColor;
  }

  svg rect.pageLabelBox {
    fill: $verovioAtPageLabelBox;
  }

  svg rect.pageBg {
    fill: #ffffff;
  }

  svg rect.sysPreview {
    fill: red;
  }
}

</style>
